import React from 'react';
import PropTypes from 'prop-types';

import Error from 'Containers/Error';

class ErrorPage extends React.PureComponent {
  render() {
    return <Error {...this.props} />;
  }
}

ErrorPage.propTypes = {
  type: PropTypes.string.isRequired,
  code: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ErrorPage;
